import * as Yup from 'yup'
import { Form } from 'react-bootstrap'

export const Schema = Yup.object().shape({
    terms: Yup.bool().required().oneOf([true], 'Die Datenschutzbestimmungen müssen akzeptiert werden'),
});

export const PrivacyConsentSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { dataSecurityUrl } = props;
    return (
        <>
            <Form.Text muted>Hinweise zur Verarbeitung von personenbezogenen Daten finden Sie in unseren <a href={dataSecurityUrl} target="_blank" rel="noreferrer" >Datenschutzbestimmungen</a> </Form.Text>
        </>
    );
};